export function RefreshLinear({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 94 94"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M85.7323 46.999C85.7323 68.3776 68.3815 85.7284 47.0029 85.7284C25.6242 85.7284 12.5724 64.1948 12.5724 64.1948M12.5724 64.1948H30.0781M12.5724 64.1948V83.5596M8.27344 46.999C8.27344 25.6203 25.4693 8.26953 47.0029 8.26953C72.8354 8.26953 85.7323 29.8031 85.7323 29.8031M85.7323 29.8031V10.4384M85.7323 29.8031H68.5364"
          stroke="currentColor"
          stroke-width="1.9918"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  );
}
